module.exports = __webpack_public_path__ + "static/media/eco.672c05b3.svg";